import ApiClient from '@/api/ApiClient';

/**
 * Google Cloud Translation API integration
 *
 * This API service handles text translation using Google Cloud Translation API.
 * The backend should implement the /translation/translate endpoint that calls
 * Google Cloud Translation API and returns the translated text.
 *
 * Example usage:
 * const response = await ApiTranslation.translateText({
 *   text: 'こんにちは',
 *   targetLanguage: 'en'
 * });
 * console.log(response.translatedText); // 'Hello'
 */

export interface TranslationRequest {
  text: string;
  sourceLanguage?: string;
  targetLanguage: string;
}

export interface TranslationResponse {
  translatedText: string;
  detectedSourceLanguage?: string;
}

export default class ApiTranslation {
  /**
   * Translate text using Google Cloud Translation API
   * @param request - Translation request containing text and target language
   * @returns Promise<TranslationResponse> - Translated text and detected source language
   */
  public static async translateText(
    request: TranslationRequest,
  ): Promise<TranslationResponse> {
    try {
      const response = await ApiClient.post('/chats/translateText', request);
      return response;
    } catch (error) {
      throw error;
    }
  }
}
